import React, { useState, useEffect } from 'react';
import { getQuests, claimQuestReward } from '../services/api';
import pointsIcon from '../assets/points_icon.png';

export default function QuestsModal({ onRewardClaimed }) {
  const [activeTab, setActiveTab] = useState('weekly');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [claimingId, setClaimingId] = useState(null);
  const [timeLeft, setTimeLeft] = useState('');

  const loadData = () => {
    getQuests().then(res => {
      setData(res.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (!data?.resetInMs) return;
    let targetTime = Date.now() + data.resetInMs;

    const updateTimer = () => {
      const remaining = targetTime - Date.now();
      if (remaining <= 0) {
        setTimeLeft('Сброс...');
        return;
      }
      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remaining / (1000 * 60)) % 60);
      setTimeLeft(`${days}д ${hours}ч ${minutes}м`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 60000);
    return () => clearInterval(interval);
  }, [data]);

  const handleClaim = async (questId) => {
    setClaimingId(questId);
    try {
      await claimQuestReward(questId);
      loadData();
      if (onRewardClaimed) onRewardClaimed();
    } catch (e) {
      alert(e.response?.data?.error || 'Ошибка получения награды');
    } finally {
      setClaimingId(null);
    }
  };

  if (loading) return <div className="loading-screen">Загрузка заданий...</div>;

  const currentList = activeTab === 'weekly' ? data.weekly : data.seasonal;

  return (
    <div className="web-quests-container">
      <div className="web-quests-header">
        <h2>Задания</h2>
        <div className="tabs quests-tabs">
          <button className={`quest-tab-button tab-button ${activeTab === 'weekly' ? 'active' : ''}`} onClick={() => setActiveTab('weekly')}>
            Недельные
          </button>
          <button className={`quest-tab-button tab-button ${activeTab === 'seasonal' ? 'active' : ''}`} onClick={() => setActiveTab('seasonal')}>
            Сезонные
          </button>
        </div>
        {activeTab === 'weekly' && (
          <div className="web-quests-timer">
            Сброс через: <strong>{timeLeft}</strong>
          </div>
        )}
      </div>

      <div className="web-quests-list">
        {currentList.map(q => {
          const percent = Math.min(100, Math.round((q.currentProgress / q.target) * 100));

          return (
            <div key={q.id} className={`web-quest-card ${q.isClaimed ? 'claimed' : (q.isCompleted ? 'completed' : '')}`}>
              <div className="web-quest-main">
                <div className="web-quest-info">
                  <span className="web-quest-title">{q.title}</span>
                  {q.link && (
                    <a href={q.link} target="_blank" rel="noopener noreferrer" className="web-quest-link">
                      Перейти к заданию ↗
                    </a>
                  )}
                </div>
                <div className="web-quest-reward">
                  +{q.reward} <img src={pointsIcon} alt="pts" className="points-icon seasonal-icon" />
                </div>
              </div>

              <div className="web-quest-progress-track">
                <div className="web-quest-progress-fill" style={{ width: `${percent}%` }}></div>
                <span className="web-quest-progress-label">
                  {q.currentProgress} / {q.target} {q.displayUnit} ({percent}%)
                </span>
              </div>

              <div className="web-quest-footer">
                {q.isClaimed ? (
                  <span className="web-quest-status done">✓ Награда получена</span>
                ) : q.isCompleted ? (
                  <button className="web-quest-claim-btn" onClick={() => handleClaim(q.id)} disabled={claimingId === q.id}>
                    {claimingId === q.id ? '...' : 'Забрать награду'}
                  </button>
                ) : (
                  <span className="web-quest-status pending">В процессе</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}